module.exports = __webpack_public_path__ + "img/MultiSelect.ee8c4d00.svg";